import Header from "./components/Header";
import LenisWrapper from "./components/LenisWrapper";
import Drawer from "./components/Drawer";
import SubNav from "./components/SuvNav";
import FooterAccess from "./components/FooterAccess";
import GoToTop from "./components/GoToTop";
import LegalNav from "./components/LegalNav";
import AboutPage from "./pages/About";
import MainHero from "./pages/MainHero";
import MainHistory from "./pages/MainHistory";
import MainProduct from "./pages/MainProduct";
import MainTech from "./pages/MainTech";
import MainContact from "./pages/MainContact";
import MainCounterUp from "./pages/MainCounterUp";
import NetworkPage from "./pages/Network";
import ProductDetail from "./pages/ProductDetail";
import ProductListing from "./pages/ProductListing";

export default class App {
    static self = null;
    static useAOS = true;
    isLocked = false;

    static init() {
        this.self = new App();
    }

    static getInstance() {
        return this.self;
    }

    constructor() {
        gsap.registerPlugin(ScrollTrigger);

        document.addEventListener("DOMContentLoaded", this.run.bind(this));
    }

    setLock(bool = false) {
        this.isLocked = bool;

        if (this.isLocked) {
            document.body.classList.add("is-lock");
            this.lenisWrapper.lenis.stop();
        } else {
            document.body.classList.remove("is-lock");
            this.lenisWrapper.lenis.start();
        }
    }

    run() {
        console.log("[App] run()");

        this.lenisWrapper = new LenisWrapper();
        this.header = new Header("header");
        this.drawer = new Drawer(this.header);
        this.header.setDrawer(this.drawer);

        this.subNav = new SubNav();
        this.footerAccess = new FooterAccess();
        this.goToTop = new GoToTop(this.lenisWrapper.lenis);
        this.legalNav = new LegalNav(this.lenisWrapper.lenis);

        // ===================================
        // Main pages
        // ===================================
        new MainHero();
        new MainCounterUp();
        new MainHistory();
        new MainProduct();
        new MainTech();
        new MainContact();

        // ===================================
        // Sub pages
        // ===================================
        new AboutPage();
        new NetworkPage();
        new ProductListing(this.lenisWrapper.lenis);
        new ProductDetail();

        if (App.useAOS) {
            AOS.init();
        }
    }
}

App.init();
